// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"67f11e33","459":"fdfec347","774":"39705572","858":"20e4fa94","883":"70879f77"}[chunkId] + ".chunk.js";
};